import { useState } from "react";
import { AlertTriangle, X } from "lucide-react";
import { useDepartmentStore } from "@/features/department";
import type { WidgetContext } from "@/features/department";

const CONTEXT_TYPE_LABELS: Record<string, string> = {
  ecommerce_product: "Product",
  ecommerce_metrics: "Metrics",
  ecommerce_ad_cost: "Ad Cost",
  ecommerce_strategy: "Strategy",
  ecommerce_portfolio: "Portfolio",
  video_editor_project: "Video Editor",
};

export function CompanionInputContextChip({
  ctx,
  index,
}: {
  ctx: WidgetContext;
  index: number;
}) {
  const removeWidgetContext = useDepartmentStore((s) => s.removeWidgetContext);
  const currentStepIndex = useDepartmentStore((s) => s.currentStepIndex);
  const [removing, setRemoving] = useState(false);
  const typeLabel = CONTEXT_TYPE_LABELS[ctx.type] || ctx.type;
  const isStale = ctx.stepIndex < currentStepIndex;

  const handleRemove = () => {
    setRemoving(true);
    setTimeout(() => removeWidgetContext(index), 150);
  };

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium transition-all duration-150 ${
        removing ? "opacity-0 scale-95" : "animate-in fade-in slide-in-from-bottom-2 duration-200"
      } ${
        isStale
          ? "bg-orange-500/15 border border-orange-500/40 text-orange-300"
          : "bg-cyan-500/15 border border-cyan-500/30 text-cyan-300"
      }`}
    >
      {isStale && <AlertTriangle className="w-3 h-3 text-orange-400 shrink-0" />}
      <span
        className={`rounded px-1 py-px text-[9px] font-bold uppercase tracking-wider ${
          isStale ? "bg-orange-500/25 text-orange-400" : "bg-cyan-500/25 text-cyan-400"
        }`}
      >
        {typeLabel}
      </span>
      <span className="max-w-[120px] truncate">{ctx.label}</span>
      <button
        type="button"
        onClick={handleRemove}
        className={`ml-0.5 rounded-full p-0.5 transition-colors ${
          isStale ? "hover:bg-orange-500/30" : "hover:bg-cyan-500/30"
        }`}
      >
        <X className="w-3 h-3" />
      </button>
    </span>
  );
}
